import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'website-empty',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyComponent {}
